<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="svg-icon">
    <path
      d="M4.3,10.68l3.47,3.39,7.88-8.92"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
</template>
